import { DefaultMeta } from '../../../../../types/partner-page-types';
import { PricingCardWrapper } from '../../../../S/pricing/components/pricing-card/pricing-card-carousel/pricing-card-carousel.component';
import { SectionHeader } from '../../../utils/section-header';
import { useDataForPlans } from '../../../utils/use-plan-data';
import { PricingCardStaticDetails } from './card-details.constants';
import {
  BUSINESS_SECTION_HEADING,
  EXPERT_SESSION_PLAN_IDS,
  LUXURY_PLAN_IDS,
  EXPERT_ASSISTED_PLANS_ID,
  EXPERT_FEATURES,
  ITR_SECTION_HEADING,
  PLAN_CAROUSEL_CLASS,
} from './constants';
import { PlanCarousal } from './planCarousal';
import { parnterPlanTransformer } from './utils';
import { CompactCards } from './CompactCards';

export interface IExplertPlanSection {
  slug: string;
  planData: {
    eas_itr: string[];
    eas_business: string[];
  };
  metaData: DefaultMeta;
}

export const ExpertAssistedPlans: React.FC<IExplertPlanSection> = ({
  planData,
  slug,
  metaData,
}): JSX.Element => {
  const cardData = parnterPlanTransformer(
    useDataForPlans(planData.eas_itr, slug)
  );
  const easPlanData = useDataForPlans(planData.eas_business, slug);
  const luxuryPlanData = useDataForPlans(LUXURY_PLAN_IDS, slug);
  const expertSessionData = useDataForPlans(EXPERT_SESSION_PLAN_IDS, slug);

  return (
    <>
      <div className="py-14 pb-14 sm:pt-14">
        {cardData.length ? (
          <>
            <SectionHeader
              heading={ITR_SECTION_HEADING}
              description=""
              id={EXPERT_ASSISTED_PLANS_ID}
            />
            <div className="flex justify-center gap-4 sm:flex-wrap sm:pb-8 pb-16">
              {EXPERT_FEATURES.map((item, index) => (
                <div
                  className="flex items-center gap-2 justify-center sm:w-[47%]"
                  key={index}
                >
                  <img src={item.iconSrc} className="h-8 w-8" />
                  <div className="font-medium text-base w-3/5 leading-snug sm:text-s-14 sm:w-auto">
                    {item.heading}
                  </div>
                </div>
              ))}
            </div>
            <PricingCardWrapper
              PricingCardStaticDetails={PricingCardStaticDetails}
              pricingPlanData={cardData}
            />
            <CompactCards
              luxuryPlanData={luxuryPlanData}
              expertSessionData={expertSessionData}
            />
          </>
        ) : (
          ''
        )}
        {easPlanData.length ? (
          <>
            <SectionHeader
              heading={BUSINESS_SECTION_HEADING}
              description=""
              id={EXPERT_ASSISTED_PLANS_ID}
            />
            <PlanCarousal
              plansData={easPlanData}
              metaData={metaData}
              customInfinite={true}
              infinite={false}
              className={PLAN_CAROUSEL_CLASS}
            ></PlanCarousal>
          </>
        ) : (
          ''
        )}
      </div>
    </>
  );
};
